
export default function init_burger_menu(){
    (function ($) {
        $( document ).ready(() =>{
            $("body").on('click', '#burger-menu', burger_click_handler);
        })
    })(jQuery);
}

/**
 * Handler on click burger element :
 * - Toggle the class of the burger button
 * - Dispatch an event ('open_mobile_nav_event' or 'close_mobile_nav_event')
 * @param e The click event
 */
function burger_click_handler(e){
    e.preventDefault();
    $(this).toggleClass('open');

    let event = $(this).hasClass("open") ? "open_mobile_nav_event" : "close_mobile_nav_event";
    $(this).trigger(event);
}